export const propertyDetails = [
  {
    id: '1',
    propertyId: 'JUB001',
    title: 'Junub Best Home',
    location: 'Hai Cinema',
    address: 'Plot 45, Hai Cinema, Juba',
    price: 750,
    currency: '$',
    type: 'rental',
    propertyType: 'House',
    bedrooms: 4,
    bathrooms: 4,
    parking: 1,
    area: 2500,
    livingRooms: 2,
    kitchens: 1,
    floors: 2,
    yearBuilt: 2020,
    ribbon: 'RENTAL',
    description:
      "Welcome to this stunning modern residence in the heart of Hai Cinema, Juba. This exceptional property features spacious interiors with abundant natural light, high-quality finishes throughout, and a thoughtfully designed layout that caters to modern family living. The home boasts elegant architectural details, premium fixtures, and a seamless flow between indoor and outdoor spaces. Located in a prime neighborhood with excellent access to schools, shopping centers, and major transportation routes, this property offers the perfect combination of luxury, convenience, and lifestyle in South Sudan's capital city.",
    gallery: [
      'https://public.readdy.ai/ai/img_res/a9387bfc5262c39776d3fa76551a90d3.jpg',
      'https://readdy.ai/api/search-image?query=Spacious%20African%20living%20room%20interior%20in%20Juba%20home%20terrazzo%20tile%20floor%20ceiling%20fan%20large%20windows%20with%20curtains%20comfortable%20fabric%20sofas%20wooden%20coffee%20table%20family%20photos%20on%20walls%20warm%20natural%20lighting%20tropical%20home%20decor%20South%20Sudan%20residential%20style%20professional%20interior%20photography&width=1200&height=800&seq=hai-cinema-living-authentic-v2&orientation=landscape',
      'https://readdy.ai/api/search-image?query=Modern%20African%20kitchen%20in%20Juba%20home%20tiled%20walls%20granite%20countertops%20gas%20stove%20stainless%20steel%20sink%20wooden%20cabinets%20bright%20window%20natural%20daylight%20clean%20organized%20South%20Sudan%20residential%20interior%20professional%20photography&width=1200&height=800&seq=hai-cinema-kitchen-authentic-v2&orientation=landscape',
      'https://readdy.ai/api/search-image?query=Master%20bedroom%20in%20Juba%20South%20Sudan%20home%20king%20bed%20with%20mosquito%20net%20ceiling%20fan%20large%20windows%20with%20curtains%20tiled%20floor%20built-in%20wardrobe%20natural%20daylight%20warm%20colors%20African%20residential%20interior%20professional%20photography&width=1200&height=800&seq=hai-cinema-bedroom-authentic-v2&orientation=landscape',
      'https://readdy.ai/api/search-image?query=Modern%20bathroom%20in%20Juba%20South%20Sudan%20home%20white%20ceramic%20tiles%20walk-in%20shower%20toilet%20washbasin%20large%20mirror%20bright%20lighting%20clean%20contemporary%20design%20African%20residential%20interior%20professional%20photography&width=1200&height=800&seq=hai-cinema-bathroom-authentic-v2&orientation=landscape',
      'https://readdy.ai/api/search-image?query=African%20home%20compound%20backyard%20in%20Juba%20South%20Sudan%20green%20lawn%20mango%20tree%20outdoor%20plastic%20chairs%20concrete%20patio%20security%20wall%20tropical%20plants%20warm%20afternoon%20sunlight%20residential%20setting%20professional%20photography&width=1200&height=800&seq=hai-cinema-backyard-authentic-v2&orientation=landscape',
      'https://readdy.ai/api/search-image?query=Dining%20area%20in%20Juba%20South%20Sudan%20home%20wooden%20dining%20table%20six%20chairs%20ceiling%20fan%20tiled%20floor%20window%20with%20curtains%20wall%20decorations%20warm%20lighting%20African%20residential%20interior%20professional%20photography&width=1200&height=800&seq=hai-cinema-dining-authentic-v2&orientation=landscape',
      'https://readdy.ai/api/search-image?query=Second%20floor%20balcony%20view%20in%20Juba%20South%20Sudan%20home%20metal%20railing%20overlooking%20compound%20palm%20trees%20neighboring%20houses%20warm%20sunset%20light%20cityscape%20African%20residential%20architecture%20professional%20photography&width=1200&height=800&seq=hai-cinema-balcony-authentic-v2&orientation=landscape'
    ],
    amenities: [
      { icon: 'ri-wifi-line', name: 'High-Speed WiFi' },
      { icon: 'ri-shield-check-line', name: 'Security System' },
      { icon: 'ri-temp-cold-line', name: 'Air Conditioning' },
      { icon: 'ri-fire-line', name: 'Generator Backup' },
      { icon: 'ri-water-flash-line', name: 'Water Tank' },
      { icon: 'ri-lightbulb-line', name: 'Solar Power' },
      { icon: 'ri-plant-line', name: 'Garden' },
      { icon: 'ri-basketball-line', name: 'Recreation Area' },
      { icon: 'ri-store-2-line', name: 'Storage Room' },
      { icon: 'ri-washing-machine-line', name: 'Laundry Room' },
      { icon: 'ri-door-open-line', name: 'Walk-in Closet' },
      { icon: 'ri-home-smile-line', name: 'Smart Home' }
    ],
    nearby: [
      { icon: 'ri-shopping-cart-line', name: 'Supermarket', distance: '0.5 km' },
      { icon: 'ri-hospital-line', name: 'Juba Teaching Hospital', distance: '1.2 km' },
      { icon: 'ri-school-line', name: 'International School', distance: '0.8 km' },
      { icon: 'ri-restaurant-line', name: 'Restaurants', distance: '0.3 km' },
      { icon: 'ri-bus-line', name: 'Bus Station', distance: '0.2 km' },
      { icon: 'ri-bank-line', name: 'Bank of South Sudan', distance: '0.6 km' }
    ],
    coordinates: {
      lat: 4.8594,
      lng: 31.5713
    },
    virtualTour: '',
    agent: {
      name: 'Diing Chan',
      title: 'Senior Property Agent',
      phone: '+211989222117',
      email: 'diing.chan@juwa.ss',
      photo: 'https://readdy.ai/api/search-image?query=Professional%20African%20female%20real%20estate%20agent%20in%20business%20attire%20smiling%20confident%20portrait%20with%20neutral%20background%20studio%20lighting%20South%20Sudanese%20woman&width=200&height=200&seq=agent-mary1&orientation=squarish'
    }
  },
  {
    id: '2',
    propertyId: 'JUB002',
    title: 'Thongpiny Villa',
    location: 'Thongpiny',
    address: 'Block 7, Thongpiny, Juba',
    price: 500,
    currency: '$',
    type: 'rental',
    propertyType: 'House',
    bedrooms: 3,
    bathrooms: 3,
    parking: 1,
    area: 1800,
    livingRooms: 2,
    kitchens: 1,
    floors: 1,
    yearBuilt: 2019,
    ribbon: 'RENTAL',
    description:
      'Discover this charming single-story residence in Thongpiny that offers comfortable and convenient living in a sought-after Juba neighborhood. The property features a well-designed layout with spacious rooms, modern amenities, and quality finishes throughout. Perfect for families seeking a peaceful environment with easy access to essential services and recreational facilities.',
    gallery: [
      'https://readdy.ai/api/search-image?query=Single%20story%20bungalow%20house%20in%20Juba%20South%20Sudan%20with%20white%20painted%20walls%20green%20metal%20roof%20wide%20veranda%20concrete%20compound%20wall%20iron%20gate%20tropical%20garden%20palm%20trees%20warm%20afternoon%20sunlight&width=1200&height=800&seq=thongpiny-ext1&orientation=landscape',
      'https://readdy.ai/api/search-image?query=Cozy%20African%20bungalow%20living%20room%20with%20comfortable%20sofas%20patterned%20cushions%20ceiling%20fan%20terrazzo%20floor%20large%20windows%20with%20lace%20curtains%20family%20photos%20on%20wall%20warm%20natural%20light&width=1200&height=800&seq=thongpiny-living1&orientation=landscape',
      'https://readdy.ai/api/search-image?query=African%20home%20kitchen%20with%20blue%20tiled%20walls%20wooden%20cabinets%20gas%20cooker%20refrigerator%20sink%20window%20with%20view%20to%20garden%20bright%20daylight%20clean%20organized%20South%20Sudan%20style&width=1200&height=800&seq=thongpiny-kitchen1&orientation=landscape',
      'https://readdy.ai/api/search-image?query=Bedroom%20in%20African%20bungalow%20with%20double%20bed%20colorful%20bedspread%20mosquito%20net%20window%20with%20curtains%20wardrobe%20ceiling%20fan%20tiled%20floor%20warm%20afternoon%20light&width=1200&height=800&seq=thongpiny-bed1&orientation=landscape',
      'https://readdy.ai/api/search-image?query=Wide%20veranda%20of%20African%20bungalow%20with%20plastic%20chairs%20small%20table%20potted%20plants%20view%20of%20compound%20garden%20security%20wall%20tropical%20setting%20relaxing%20outdoor%20space&width=1200&height=800&seq=thongpiny-veranda1&orientation=landscape',
      'https://readdy.ai/api/search-image?query=Bathroom%20in%20African%20home%20with%20ceramic%20tiles%20shower%20corner%20toilet%20washbasin%20mirror%20small%20window%20natural%20ventilation%20clean%20simple%20design&width=1200&height=800&seq=thongpiny-bath1&orientation=landscape'
    ],
    amenities: [
      { icon: 'ri-wifi-line', name: 'High-Speed WiFi' },
      { icon: 'ri-shield-check-line', name: 'Security System' },
      { icon: 'ri-temp-cold-line', name: 'Air Conditioning' },
      { icon: 'ri-water-flash-line', name: 'Water Tank' },
      { icon: 'ri-plant-line', name: 'Garden' },
      { icon: 'ri-car-line', name: 'Parking Space' }
    ],
    nearby: [
      { icon: 'ri-shopping-cart-line', name: 'Local Market', distance: '0.4 km' },
      { icon: 'ri-hospital-line', name: 'Clinic', distance: '1.5 km' },
      { icon: 'ri-school-line', name: 'Primary School', distance: '0.7 km' },
      { icon: 'ri-restaurant-line', name: 'Restaurants', distance: '0.2 km' }
    ],
    coordinates: {
      lat: 4.845,
      lng: 31.565
    },
    virtualTour: '',
    agent: {
      name: 'Diing Chan',
      title: 'Senior Property Agent',
      phone: '+211989222117',
      email: 'diing.chan@juwa.ss',
      photo: 'https://readdy.ai/api/search-image?query=Professional%20African%20male%20real%20estate%20agent%20in%20business%20suit%20smiling%20confident%20portrait%20with%20neutral%20background%20studio%20lighting%20South%20Sudanese%20man&width=200&height=200&seq=agent-john1&orientation=squarish'
    }
  },
  {
    id: '3',
    propertyId: 'JUB003',
    title: 'Gudele Modern Apartment',
    location: 'Gudele',
    address: 'Gudele Phase 2, Block 15, Juba',
    price: 350,
    currency: '$',
    type: 'rental',
    propertyType: 'Apartment',
    bedrooms: 2,
    bathrooms: 2,
    parking: 1,
    area: 1200,
    livingRooms: 1,
    kitchens: 1,
    floors: 3,
    yearBuilt: 2021,
    ribbon: 'RENTAL',
    description:
      'Modern apartment living in the rapidly developing Gudele area. This well-appointed unit offers contemporary finishes, efficient use of space, and all the amenities needed for comfortable urban living. Ideal for young professionals or small families looking for affordable quality housing in Juba.',
    gallery: [
      'https://readdy.ai/api/search-image?query=Three%20story%20apartment%20building%20in%20Juba%20South%20Sudan%20with%20beige%20exterior%20paint%20metal%20balcony%20railings%20ground%20floor%20shops%20paved%20parking%20area%20palm%20trees%20urban%20African%20residential%20architecture&width=1200&height=800&seq=gudele-ext1&orientation=landscape',
      'https://readdy.ai/api/search-image?query=Modern%20African%20apartment%20living%20room%20with%20L-shaped%20sofa%20TV%20stand%20ceiling%20fan%20tiled%20floor%20sliding%20glass%20door%20to%20balcony%20bright%20natural%20light%20contemporary%20decor&width=1200&height=800&seq=gudele-living1&orientation=landscape',
      'https://readdy.ai/api/search-image?query=Compact%20modern%20kitchen%20in%20African%20apartment%20with%20fitted%20cabinets%20gas%20stove%20countertop%20microwave%20small%20dining%20area%20window%20bright%20lighting%20efficient%20design&width=1200&height=800&seq=gudele-kitchen1&orientation=landscape',
      'https://readdy.ai/api/search-image?query=Apartment%20bedroom%20in%20Juba%20with%20queen%20bed%20built-in%20wardrobe%20air%20conditioning%20unit%20window%20with%20blinds%20tiled%20floor%20modern%20minimalist%20style&width=1200&height=800&seq=gudele-bed1&orientation=landscape',
      'https://readdy.ai/api/search-image?query=Apartment%20balcony%20view%20in%20Juba%20overlooking%20busy%20street%20with%20shops%20cars%20pedestrians%20urban%20African%20cityscape%20afternoon%20light&width=1200&height=800&seq=gudele-balcony1&orientation=landscape',
      'https://readdy.ai/api/search-image?query=Modern%20apartment%20bathroom%20with%20shower%20cubicle%20toilet%20vanity%20mirror%20tiles%20bright%20lighting%20small%20window%20contemporary%20African%20urban%20home&width=1200&height=800&seq=gudele-bath1&orientation=landscape'
    ],
    amenities: [
      { icon: 'ri-wifi-line', name: 'High-Speed WiFi' },
      { icon: 'ri-shield-check-line', name: 'Security Guard' },
      { icon: 'ri-temp-cold-line', name: 'Air Conditioning' },
      { icon: 'ri-water-flash-line', name: 'Water Supply' },
      { icon: 'ri-car-line', name: 'Parking Space' },
      { icon: 'ri-fire-line', name: 'Backup Generator' }
    ],
    nearby: [
      { icon: 'ri-shopping-cart-line', name: 'Gudele Market', distance: '0.3 km' },
      { icon: 'ri-hospital-line', name: 'Health Center', distance: '0.8 km' },
      { icon: 'ri-school-line', name: 'Gudele Primary', distance: '0.5 km' },
      { icon: 'ri-bus-line', name: 'Bus Stop', distance: '0.1 km' }
    ],
    coordinates: {
      lat: 4.8712,
      lng: 31.5489
    },
    virtualTour: '',
    agent: {
      name: 'Diing Chan',
      title: 'Senior Property Agent',
      phone: '+211989222117',
      email: 'diing.chan@juwa.ss',
      photo: 'https://readdy.ai/api/search-image?query=Professional%20young%20African%20woman%20real%20estate%20agent%20friendly%20smile%20business%20casual%20attire%20portrait%20neutral%20background%20South%20Sudanese&width=200&height=200&seq=agent-sarah1&orientation=squarish'
    }
  },
  {
    id: '4',
    propertyId: 'JUB004',
    title: 'Tongping Diplomatic Mansion',
    location: 'Tongping',
    address: 'Plot 12, Tongping, Juba',
    price: 450000,
    currency: '$',
    type: 'sale',
    propertyType: 'House',
    bedrooms: 6,
    bathrooms: 5,
    parking: 3,
    area: 5000,
    livingRooms: 3,
    kitchens: 2,
    floors: 2,
    yearBuilt: 2018,
    ribbon: 'FOR SALE',
    description:
      'Prestigious mansion in the exclusive Tongping diplomatic quarter. This exceptional property offers unparalleled luxury with expansive living spaces, premium finishes, and resort-style amenities including a private swimming pool. Perfect for diplomats, executives, or discerning buyers seeking the finest residence in Juba.',
    gallery: [
      'https://readdy.ai/api/search-image?query=Luxury%20two%20story%20mansion%20in%20Tongping%20Juba%20with%20white%20exterior%20grand%20entrance%20columns%20large%20windows%20manicured%20lawn%20swimming%20pool%20visible%20high%20security%20wall%20electric%20gate%20diplomatic%20residence%20style&width=1200&height=800&seq=tongping-ext1&orientation=landscape',
      'https://readdy.ai/api/search-image?query=Grand%20living%20room%20in%20African%20luxury%20mansion%20with%20high%20ceiling%20crystal%20chandelier%20marble%20floor%20elegant%20sofas%20artwork%20on%20walls%20large%20windows%20natural%20light%20premium%20interior%20design&width=1200&height=800&seq=tongping-living1&orientation=landscape',
      'https://readdy.ai/api/search-image?query=Luxury%20kitchen%20in%20African%20mansion%20with%20island%20counter%20marble%20tops%20high-end%20appliances%20wine%20cooler%20pendant%20lights%20spacious%20modern%20design&width=1200&height=800&seq=tongping-kitchen1&orientation=landscape',
      'https://readdy.ai/api/search-image?query=Master%20suite%20in%20luxury%20African%20home%20with%20king%20bed%20premium%20bedding%20sitting%20area%20large%20windows%20with%20drapes%20walk-in%20closet%20entrance%20elegant%20decor&width=1200&height=800&seq=tongping-master1&orientation=landscape',
      'https://readdy.ai/api/search-image?query=Private%20swimming%20pool%20in%20African%20mansion%20compound%20with%20blue%20water%20pool%20deck%20sun%20loungers%20tropical%20landscaping%20palm%20trees%20privacy%20wall%20evening%20lighting&width=1200&height=800&seq=tongping-pool1&orientation=landscape',
      'https://readdy.ai/api/search-image?query=Luxury%20bathroom%20in%20African%20mansion%20with%20freestanding%20bathtub%20double%20vanity%20marble%20tiles%20large%20mirror%20premium%20fixtures%20natural%20light&width=1200&height=800&seq=tongping-bath1&orientation=landscape',
      'https://readdy.ai/api/search-image?query=Formal%20dining%20room%20in%20African%20luxury%20home%20with%20long%20wooden%20table%20ten%20chairs%20chandelier%20buffet%20cabinet%20artwork%20elegant%20curtains&width=1200&height=800&seq=tongping-dining1&orientation=landscape',
      'https://readdy.ai/api/search-image?query=Home%20office%20study%20in%20African%20mansion%20with%20wooden%20desk%20leather%20chair%20bookshelves%20large%20window%20garden%20view%20premium%20furnishings&width=1200&height=800&seq=tongping-office1&orientation=landscape'
    ],
    amenities: [
      { icon: 'ri-wifi-line', name: 'Fiber Internet' },
      { icon: 'ri-shield-check-line', name: '24/7 Security' },
      { icon: 'ri-temp-cold-line', name: 'Central AC' },
      { icon: 'ri-fire-line', name: 'Generator' },
      { icon: 'ri-water-flash-line', name: 'Borehole' },
      { icon: 'ri-lightbulb-line', name: 'Solar System' },
      { icon: 'ri-swimming-line', name: 'Swimming Pool' },
      { icon: 'ri-plant-line', name: 'Landscaped Garden' },
      { icon: 'ri-home-gear-line', name: 'Staff Quarters' },
      { icon: 'ri-car-line', name: '3-Car Garage' }
    ],
    nearby: [
      { icon: 'ri-government-line', name: 'UN Compound', distance: '0.5 km' },
      { icon: 'ri-hotel-line', name: 'Pyramid Hotel', distance: '0.8 km' },
      { icon: 'ri-hospital-line', name: 'International Clinic', distance: '1.0 km' },
      { icon: 'ri-plane-line', name: 'Juba Airport', distance: '3.5 km' }
    ],
    coordinates: {
      lat: 4.8523,
      lng: 31.5834
    },
    virtualTour: '',
    agent: {
      name: 'Diing Chan',
      title: 'Luxury Property Specialist',
      phone: '+211989222117',
      email: 'diing.chan@juwa.ss',
      photo: 'https://readdy.ai/api/search-image?query=Distinguished%20African%20male%20real%20estate%20executive%20in%20formal%20suit%20professional%20portrait%20confident%20expression%20neutral%20background%20South%20Sudanese%20businessman&width=200&height=200&seq=agent-peter1&orientation=squarish'
    }
  },
  {
    id: '5',
    propertyId: 'JUB005',
    title: 'Jebel Kujur Heights',
    location: 'Jebel Kujur',
    address: 'Jebel Kujur Road, Juba',
    price: 280000,
    currency: '$',
    type: 'sale',
    propertyType: 'House',
    bedrooms: 4,
    bathrooms: 3,
    parking: 2,
    area: 3200,
    livingRooms: 2,
    kitchens: 1,
    floors: 2,
    yearBuilt: 2022,
    ribbon: 'FOR SALE',
    description:
      'Stunning hillside property with panoramic views of Juba and the surrounding landscape. This modern home in Jebel Kujur offers a unique living experience with cool breezes, privacy, and breathtaking scenery. The elevated location provides natural security and a serene environment away from the city bustle.',
    gallery: [
      'https://readdy.ai/api/search-image?query=Modern%20hillside%20house%20in%20Jebel%20Kujur%20Juba%20with%20contemporary%20design%20large%20windows%20panoramic%20view%20terrace%20stone%20accents%20green%20landscaping%20mountain%20backdrop%20clear%20sky&width=1200&height=800&seq=jebel-ext1&orientation=landscape',
      'https://readdy.ai/api/search-image?query=Open%20plan%20living%20room%20with%20floor%20to%20ceiling%20windows%20panoramic%20city%20view%20comfortable%20modern%20furniture%20natural%20stone%20accent%20wall%20high%20ceiling%20mountain%20home&width=1200&height=800&seq=jebel-living1&orientation=landscape',
      'https://readdy.ai/api/search-image?query=Modern%20kitchen%20with%20view%20of%20mountains%20through%20window%20sleek%20cabinets%20stone%20countertops%20integrated%20appliances%20breakfast%20bar%20natural%20light&width=1200&height=800&seq=jebel-kitchen1&orientation=landscape',
      'https://readdy.ai/api/search-image?query=Bedroom%20with%20large%20window%20overlooking%20Juba%20city%20lights%20comfortable%20bed%20modern%20furniture%20balcony%20access%20evening%20ambiance%20mountain%20residence&width=1200&height=800&seq=jebel-bed1&orientation=landscape',
      'https://readdy.ai/api/search-image?query=Outdoor%20terrace%20with%20seating%20area%20overlooking%20Juba%20cityscape%20sunset%20view%20wooden%20deck%20potted%20plants%20mountain%20breeze%20relaxing%20atmosphere&width=1200&height=800&seq=jebel-terrace1&orientation=landscape',
      'https://readdy.ai/api/search-image?query=Modern%20bathroom%20with%20natural%20stone%20tiles%20glass%20shower%20large%20mirror%20view%20window%20contemporary%20fixtures%20mountain%20home%20design&width=1200&height=800&seq=jebel-bath1&orientation=landscape'
    ],
    amenities: [
      { icon: 'ri-wifi-line', name: 'High-Speed WiFi' },
      { icon: 'ri-shield-check-line', name: 'Security System' },
      { icon: 'ri-temp-cold-line', name: 'Air Conditioning' },
      { icon: 'ri-fire-line', name: 'Generator' },
      { icon: 'ri-water-flash-line', name: 'Water Storage' },
      { icon: 'ri-lightbulb-line', name: 'Solar Panels' },
      { icon: 'ri-landscape-line', name: 'Panoramic Views' },
      { icon: 'ri-car-line', name: 'Double Garage' }
    ],
    nearby: [
      { icon: 'ri-restaurant-line', name: 'Jebel Restaurant', distance: '1.2 km' },
      { icon: 'ri-hospital-line', name: 'Medical Center', distance: '2.5 km' },
      { icon: 'ri-store-line', name: 'Shopping Area', distance: '3.0 km' },
      { icon: 'ri-road-map-line', name: 'Main Road', distance: '0.8 km' }
    ],
    coordinates: {
      lat: 4.8234,
      lng: 31.5912
    },
    virtualTour: '',
    agent: {
      name: 'Diing Chan',
      title: 'Property Consultant',
      phone: '+211989222117',
      email: 'diing.chan@juwa.ss',
      photo: 'https://readdy.ai/api/search-image?query=Professional%20African%20woman%20real%20estate%20agent%20warm%20smile%20business%20attire%20portrait%20neutral%20background%20South%20Sudanese%20professional&width=200&height=200&seq=agent-grace1&orientation=squarish'
    }
  },
  {
    id: '6',
    propertyId: 'JUB006',
    title: 'Munuki Family Home',
    location: 'Munuki',
    address: 'Block 23, Munuki, Juba',
    price: 400,
    currency: '$',
    type: 'rental',
    propertyType: 'House',
    bedrooms: 3,
    bathrooms: 2,
    parking: 1,
    area: 1600,
    livingRooms: 1,
    kitchens: 1,
    floors: 1,
    yearBuilt: 2017,
    ribbon: 'RENTAL',
    description:
      'Comfortable family home in the established Munuki neighborhood. This well-maintained property offers practical living spaces, a secure compound, and a friendly community atmosphere. Perfect for families seeking affordable housing with good access to schools, markets, and public transportation.',
    gallery: [
      'https://readdy.ai/api/search-image?query=Traditional%20African%20family%20house%20in%20Munuki%20Juba%20with%20painted%20concrete%20walls%20metal%20roof%20front%20porch%20compound%20wall%20with%20gate%20fruit%20trees%20in%20yard%20children%20playing%20warm%20afternoon%20light&width=1200&height=800&seq=munuki-ext1&orientation=landscape',
      'https://readdy.ai/api/search-image?query=African%20family%20living%20room%20with%20comfortable%20sofas%20TV%20cabinet%20family%20photos%20on%20wall%20ceiling%20fan%20terrazzo%20floor%20colorful%20cushions%20warm%20homey%20atmosphere&width=1200&height=800&seq=munuki-living1&orientation=landscape',
      'https://readdy.ai/api/search-image?query=Simple%20African%20kitchen%20with%20gas%20stove%20wooden%20cabinets%20sink%20window%20to%20backyard%20cooking%20utensils%20organized%20shelves%20clean%20functional%20design&width=1200&height=800&seq=munuki-kitchen1&orientation=landscape',
      'https://readdy.ai/api/search-image?query=Children%20bedroom%20in%20African%20home%20with%20bunk%20beds%20colorful%20bedding%20study%20desk%20window%20with%20curtains%20toys%20organized%20shelves%20bright%20cheerful%20room&width=1200&height=800&seq=munuki-kids1&orientation=landscape',
      'https://readdy.ai/api/search-image?query=African%20home%20backyard%20with%20clothesline%20mango%20tree%20vegetable%20garden%20outdoor%20cooking%20area%20children%20play%20equipment%20family%20compound&width=1200&height=800&seq=munuki-yard1&orientation=landscape',
      'https://readdy.ai/api/search-image?query=Simple%20bathroom%20in%20African%20home%20with%20tiles%20shower%20toilet%20basin%20mirror%20functional%20clean%20design&width=1200&height=800&seq=munuki-bath1&orientation=landscape'
    ],
    amenities: [
      { icon: 'ri-wifi-line', name: 'WiFi Ready' },
      { icon: 'ri-shield-check-line', name: 'Secure Compound' },
      { icon: 'ri-water-flash-line', name: 'Water Tank' },
      { icon: 'ri-plant-line', name: 'Fruit Trees' },
      { icon: 'ri-car-line', name: 'Parking' },
      { icon: 'ri-community-line', name: 'Family Friendly' }
    ],
    nearby: [
      { icon: 'ri-shopping-cart-line', name: 'Munuki Market', distance: '0.3 km' },
      { icon: 'ri-school-line', name: 'Primary School', distance: '0.4 km' },
      { icon: 'ri-hospital-line', name: 'Health Clinic', distance: '0.6 km' },
      { icon: 'ri-building-line', name: 'Church', distance: '0.2 km' }
    ],
    coordinates: {
      lat: 4.8678,
      lng: 31.5567
    },
    virtualTour: '',
    agent: {
      name: 'Diing Chan',
      title: 'Family Housing Specialist',
      phone: '+211989222117',
      email: 'diing.chan@juwa.ss',
      photo: 'https://readdy.ai/api/search-image?query=Friendly%20African%20male%20real%20estate%20agent%20casual%20professional%20attire%20warm%20smile%20portrait%20neutral%20background%20South%20Sudanese%20man&width=200&height=200&seq=agent-james1&orientation=squarish'
    }
  },
  {
    id: '7',
    propertyId: 'JUB007',
    title: 'Hai Referendum Executive',
    location: 'Hai Referendum',
    address: 'Plot 8, Hai Referendum, Juba',
    price: 320000,
    currency: '$',
    type: 'sale',
    propertyType: 'House',
    bedrooms: 5,
    bathrooms: 4,
    parking: 2,
    area: 3800,
    livingRooms: 2,
    kitchens: 1,
    floors: 2,
    yearBuilt: 2020,
    ribbon: 'FOR SALE',
    description:
      'Executive residence in the prestigious Hai Referendum area. This impressive property combines modern architecture with practical design, offering generous living spaces, quality finishes, and excellent amenities. Ideal for business executives and professionals seeking a distinguished address in Juba.',
    gallery: [
      'https://readdy.ai/api/search-image?query=Executive%20two%20story%20house%20in%20Hai%20Referendum%20Juba%20modern%20African%20architecture%20cream%20walls%20large%20windows%20balcony%20manicured%20lawn%20paved%20driveway%20security%20gate%20professional%20landscaping&width=1200&height=800&seq=referendum-ext1&orientation=landscape',
      'https://readdy.ai/api/search-image?query=Executive%20living%20room%20with%20leather%20sofas%20glass%20coffee%20table%20large%20TV%20modern%20artwork%20high%20ceiling%20recessed%20lighting%20marble%20floor%20elegant%20African%20home&width=1200&height=800&seq=referendum-living1&orientation=landscape',
      'https://readdy.ai/api/search-image?query=Modern%20executive%20kitchen%20with%20dark%20cabinets%20granite%20counters%20stainless%20appliances%20island%20with%20bar%20stools%20pendant%20lights%20wine%20rack&width=1200&height=800&seq=referendum-kitchen1&orientation=landscape',
      'https://readdy.ai/api/search-image?query=Master%20bedroom%20suite%20with%20king%20bed%20upholstered%20headboard%20sitting%20area%20large%20windows%20with%20elegant%20curtains%20walk-in%20closet%20entrance&width=1200&height=800&seq=referendum-master1&orientation=landscape',
      'https://readdy.ai/api/search-image?query=Home%20office%20in%20executive%20African%20residence%20with%20wooden%20desk%20executive%20chair%20bookshelves%20computer%20setup%20window%20with%20garden%20view%20professional%20atmosphere&width=1200&height=800&seq=referendum-office1&orientation=landscape',
      'https://readdy.ai/api/search-image?query=Executive%20bathroom%20with%20double%20vanity%20large%20mirror%20bathtub%20separate%20shower%20marble%20tiles%20modern%20fixtures%20elegant%20design&width=1200&height=800&seq=referendum-bath1&orientation=landscape',
      'https://readdy.ai/api/search-image?query=Outdoor%20entertainment%20area%20with%20covered%20patio%20BBQ%20grill%20outdoor%20furniture%20garden%20lighting%20evening%20setting%20executive%20African%20home&width=1200&height=800&seq=referendum-patio1&orientation=landscape'
    ],
    amenities: [
      { icon: 'ri-wifi-line', name: 'Fiber Internet' },
      { icon: 'ri-shield-check-line', name: 'CCTV Security' },
      { icon: 'ri-temp-cold-line', name: 'Central AC' },
      { icon: 'ri-fire-line', name: 'Generator' },
      { icon: 'ri-water-flash-line', name: 'Borehole' },
      { icon: 'ri-lightbulb-line', name: 'Solar Backup' },
      { icon: 'ri-car-line', name: 'Double Garage' },
      { icon: 'ri-home-gear-line', name: 'Staff Room' }
    ],
    nearby: [
      { icon: 'ri-government-line', name: 'Government Offices', distance: '0.8 km' },
      { icon: 'ri-bank-line', name: 'Commercial Bank', distance: '0.5 km' },
      { icon: 'ri-hotel-line', name: 'Business Hotel', distance: '1.0 km' },
      { icon: 'ri-restaurant-line', name: 'Fine Dining', distance: '0.6 km' }
    ],
    coordinates: {
      lat: 4.8456,
      lng: 31.5789
    },
    virtualTour: '',
    agent: {
      name: 'Diing Chan',
      title: 'Executive Property Agent',
      phone: '+211989222117',
      email: 'diing.chan@juwa.ss',
      photo: 'https://readdy.ai/api/search-image?query=Professional%20African%20businesswoman%20real%20estate%20agent%20elegant%20attire%20confident%20smile%20portrait%20neutral%20background%20South%20Sudanese%20executive%20woman&width=200&height=200&seq=agent-rebecca1&orientation=squarish'
    }
  },
  {
    id: '8',
    propertyId: 'JUB008',
    title: 'Kator Studio Apartment',
    location: 'Kator',
    address: 'Kator Main Road, Juba',
    price: 200,
    currency: '$',
    type: 'rental',
    propertyType: 'Apartment',
    bedrooms: 1,
    bathrooms: 1,
    parking: 0,
    area: 450,
    livingRooms: 1,
    kitchens: 1,
    floors: 2,
    yearBuilt: 2021,
    ribbon: 'RENTAL',
    description:
      'Affordable studio apartment in the vibrant Kator area. This compact but well-designed unit is perfect for singles or young professionals seeking convenient city living. Located near shops, restaurants, and public transport, with all essential amenities included.',
    gallery: [
      'https://readdy.ai/api/search-image?query=Two%20story%20apartment%20building%20in%20Kator%20Juba%20with%20shops%20on%20ground%20floor%20residential%20units%20above%20painted%20exterior%20balconies%20busy%20street%20with%20pedestrians%20urban%20African%20setting&width=1200&height=800&seq=kator-ext1&orientation=landscape',
      'https://readdy.ai/api/search-image?query=Small%20studio%20apartment%20living%20area%20with%20sofa%20bed%20TV%20corner%20kitchenette%20tiled%20floor%20window%20with%20curtains%20compact%20efficient%20African%20urban%20living&width=1200&height=800&seq=kator-studio1&orientation=landscape',
      'https://readdy.ai/api/search-image?query=Compact%20kitchenette%20in%20studio%20apartment%20with%20small%20stove%20sink%20mini%20fridge%20counter%20space%20wall%20cabinets%20efficient%20design&width=1200&height=800&seq=kator-kitchen1&orientation=landscape',
      'https://readdy.ai/api/search-image?query=Small%20bathroom%20in%20African%20apartment%20with%20shower%20toilet%20sink%20mirror%20tiles%20functional%20compact%20design&width=1200&height=800&seq=kator-bath1&orientation=landscape',
      'https://readdy.ai/api/search-image?query=View%20from%20apartment%20window%20of%20busy%20Kator%20street%20market%20stalls%20pedestrians%20shops%20urban%20African%20life%20daytime&width=1200&height=800&seq=kator-view1&orientation=landscape'
    ],
    amenities: [
      { icon: 'ri-wifi-line', name: 'WiFi Available' },
      { icon: 'ri-shield-check-line', name: 'Security Guard' },
      { icon: 'ri-water-flash-line', name: 'Water Supply' },
      { icon: 'ri-lightbulb-line', name: 'Electricity' },
      { icon: 'ri-store-line', name: 'Shops Nearby' }
    ],
    nearby: [
      { icon: 'ri-shopping-cart-line', name: 'Kator Market', distance: '0.1 km' },
      { icon: 'ri-restaurant-line', name: 'Local Restaurants', distance: '0.1 km' },
      { icon: 'ri-bus-line', name: 'Bus Station', distance: '0.2 km' },
      { icon: 'ri-hospital-line', name: 'Pharmacy', distance: '0.3 km' }
    ],
    coordinates: {
      lat: 4.8534,
      lng: 31.5623
    },
    virtualTour: '',
    agent: {
      name: 'Diing Chan',
      title: 'Rental Agent',
      phone: '+211989222117',
      email: 'diing.chan@juwa.ss',
      photo: 'https://readdy.ai/api/search-image?query=Young%20African%20male%20real%20estate%20agent%20casual%20professional%20friendly%20smile%20portrait%20neutral%20background%20South%20Sudanese%20young%20professional&width=200&height=200&seq=agent-david1&orientation=squarish'
    }
  },
  {
    id: '9',
    propertyId: 'JUB009',
    title: 'Nyakuron Prime Land',
    location: 'Nyakuron',
    address: 'Nyakuron Cultural Area, Juba',
    price: 180000,
    currency: '$',
    type: 'sale',
    propertyType: 'Land',
    bedrooms: 0,
    bathrooms: 0,
    parking: 0,
    area: 8000,
    livingRooms: 0,
    kitchens: 0,
    floors: 0,
    yearBuilt: 0,
    ribbon: 'FOR SALE',
    description:
      'Prime development land in the sought-after Nyakuron area near the Cultural Center. This substantial plot offers excellent potential for residential or commercial development. Flat terrain, clear title, and all utilities available at the boundary. A rare opportunity in one of Juba\'s most desirable locations.',
    gallery: [
      'https://readdy.ai/api/search-image?query=Large%20empty%20plot%20of%20land%20in%20Nyakuron%20Juba%20with%20boundary%20markers%20flat%20terrain%20some%20trees%20neighboring%20houses%20visible%20clear%20sky%20development%20potential%20African%20urban%20land&width=1200&height=800&seq=nyakuron-land1&orientation=landscape',
      'https://readdy.ai/api/search-image?query=Corner%20view%20of%20vacant%20land%20plot%20in%20Juba%20showing%20road%20access%20neighboring%20properties%20boundary%20wall%20partial%20construction%20nearby%20urban%20development%20area&width=1200&height=800&seq=nyakuron-land2&orientation=landscape',
      'https://readdy.ai/api/search-image?query=Aerial%20perspective%20of%20land%20plot%20in%20African%20city%20showing%20size%20dimensions%20neighboring%20buildings%20roads%20infrastructure%20development%20potential&width=1200&height=800&seq=nyakuron-land3&orientation=landscape',
      'https://readdy.ai/api/search-image?query=Land%20survey%20markers%20on%20vacant%20plot%20in%20Juba%20with%20measuring%20tape%20boundary%20stones%20clear%20demarcation%20professional%20land%20assessment&width=1200&height=800&seq=nyakuron-land4&orientation=landscape',
      'https://readdy.ai/api/search-image?query=Street%20view%20showing%20access%20road%20to%20vacant%20land%20plot%20in%20Nyakuron%20Juba%20with%20utility%20poles%20neighboring%20houses%20paved%20road%20infrastructure&width=1200&height=800&seq=nyakuron-land5&orientation=landscape'
    ],
    amenities: [
      { icon: 'ri-ruler-line', name: '8000 sqm Plot' },
      { icon: 'ri-file-text-line', name: 'Clear Title' },
      { icon: 'ri-road-map-line', name: 'Road Access' },
      { icon: 'ri-flashlight-line', name: 'Electricity Nearby' },
      { icon: 'ri-water-flash-line', name: 'Water Available' },
      { icon: 'ri-building-line', name: 'Development Ready' }
    ],
    nearby: [
      { icon: 'ri-building-2-line', name: 'Nyakuron Cultural Center', distance: '0.5 km' },
      { icon: 'ri-government-line', name: 'Government Buildings', distance: '1.0 km' },
      { icon: 'ri-bank-line', name: 'Banks', distance: '0.8 km' },
      { icon: 'ri-hotel-line', name: 'Hotels', distance: '0.6 km' }
    ],
    coordinates: {
      lat: 4.8612,
      lng: 31.5845
    },
    virtualTour: '',
    agent: {
      name: 'Diing Chan',
      title: 'Land & Development Specialist',
      phone: '+211989222117',
      email: 'diing.chan@juwa.ss',
      photo: 'https://readdy.ai/api/search-image?query=Mature%20African%20male%20real%20estate%20professional%20formal%20attire%20experienced%20confident%20portrait%20neutral%20background%20South%20Sudanese%20businessman&width=200&height=200&seq=agent-michael1&orientation=squarish'
    }
  },
  {
    id: '10',
    propertyId: 'JUB010',
    title: 'Hai Malakal Colonial',
    location: 'Hai Malakal',
    address: 'Plot 15, Hai Malakal, Juba',
    price: 380000,
    currency: '$',
    type: 'sale',
    propertyType: 'House',
    bedrooms: 5,
    bathrooms: 4,
    parking: 2,
    area: 4200,
    livingRooms: 2,
    kitchens: 1,
    floors: 1,
    yearBuilt: 1985,
    ribbon: 'FOR SALE',
    description:
      'Charming colonial-era residence in historic Hai Malakal. This character property has been lovingly maintained and updated while preserving its original architectural features. Spacious rooms, high ceilings, and mature gardens create a unique living experience with old-world charm in modern Juba.',
    gallery: [
      'https://readdy.ai/api/search-image?query=Colonial%20style%20single%20story%20house%20in%20Hai%20Malakal%20Juba%20with%20wide%20veranda%20white%20columns%20green%20shutters%20mature%20garden%20large%20trees%20historic%20African%20architecture%20well%20maintained&width=1200&height=800&seq=malakal-ext1&orientation=landscape',
      'https://readdy.ai/api/search-image?query=Colonial%20living%20room%20with%20high%20ceiling%20wooden%20beams%20antique%20furniture%20ceiling%20fans%20large%20windows%20with%20shutters%20terrazzo%20floor%20vintage%20African%20home%20character&width=1200&height=800&seq=malakal-living1&orientation=landscape',
      'https://readdy.ai/api/search-image?query=Vintage%20kitchen%20updated%20with%20modern%20appliances%20original%20tile%20work%20wooden%20cabinets%20large%20windows%20colonial%20African%20home%20character%20preserved&width=1200&height=800&seq=malakal-kitchen1&orientation=landscape',
      'https://readdy.ai/api/search-image?query=Colonial%20bedroom%20with%20four%20poster%20bed%20mosquito%20net%20high%20ceiling%20ceiling%20fan%20large%20windows%20with%20wooden%20shutters%20vintage%20furniture%20African%20heritage%20home&width=1200&height=800&seq=malakal-bed1&orientation=landscape',
      'https://readdy.ai/api/search-image?query=Wide%20colonial%20veranda%20with%20rocking%20chairs%20potted%20plants%20view%20of%20mature%20garden%20large%20trees%20shaded%20relaxing%20space%20historic%20African%20home&width=1200&height=800&seq=malakal-veranda1&orientation=landscape',
      'https://readdy.ai/api/search-image?query=Mature%20garden%20of%20colonial%20home%20with%20large%20mango%20trees%20flowering%20plants%20lawn%20pathways%20outdoor%20seating%20peaceful%20African%20compound&width=1200&height=800&seq=malakal-garden1&orientation=landscape'
    ],
    amenities: [
      { icon: 'ri-wifi-line', name: 'WiFi Installed' },
      { icon: 'ri-shield-check-line', name: 'Security Wall' },
      { icon: 'ri-temp-cold-line', name: 'AC Units' },
      { icon: 'ri-fire-line', name: 'Generator' },
      { icon: 'ri-water-flash-line', name: 'Water Tank' },
      { icon: 'ri-plant-line', name: 'Mature Garden' },
      { icon: 'ri-home-heart-line', name: 'Historic Character' },
      { icon: 'ri-car-line', name: 'Covered Parking' }
    ],
    nearby: [
      { icon: 'ri-building-line', name: 'Historic District', distance: '0.2 km' },
      { icon: 'ri-restaurant-line', name: 'Restaurants', distance: '0.4 km' },
      { icon: 'ri-hospital-line', name: 'Hospital', distance: '1.5 km' },
      { icon: 'ri-bank-line', name: 'Banks', distance: '0.8 km' }
    ],
    coordinates: {
      lat: 4.8489,
      lng: 31.5678
    },
    virtualTour: '',
    agent: {
      name: 'Diing Chan',
      title: 'Heritage Property Specialist',
      phone: '+211989222117',
      email: 'diing.chan@juwa.ss',
      photo: 'https://readdy.ai/api/search-image?query=Elegant%20African%20woman%20real%20estate%20agent%20professional%20attire%20warm%20smile%20portrait%20neutral%20background%20South%20Sudanese%20professional%20woman&width=200&height=200&seq=agent-elizabeth1&orientation=squarish'
    }
  },
  {
    id: '11',
    propertyId: 'JUB011',
    title: 'Juba Town Penthouse',
    location: 'Juba Town',
    address: 'Central Business District, Juba',
    price: 1200,
    currency: '$',
    type: 'rental',
    propertyType: 'Apartment',
    bedrooms: 3,
    bathrooms: 2,
    parking: 1,
    area: 2000,
    livingRooms: 1,
    kitchens: 1,
    floors: 6,
    yearBuilt: 2023,
    ribbon: 'RENTAL',
    description:
      'Luxurious penthouse apartment in the heart of Juba\'s Central Business District. This premium residence offers stunning city views, contemporary finishes, and exclusive amenities. Perfect for executives seeking sophisticated urban living with easy access to business centers, hotels, and entertainment.',
    gallery: [
      'https://readdy.ai/api/search-image?query=Modern%20high%20rise%20apartment%20building%20in%20Juba%20CBD%20glass%20facade%20balconies%20urban%20African%20cityscape%20commercial%20area%20busy%20streets%20contemporary%20architecture&width=1200&height=800&seq=cbd-ext1&orientation=landscape',
      'https://readdy.ai/api/search-image?query=Penthouse%20living%20room%20with%20floor%20to%20ceiling%20windows%20panoramic%20city%20view%20modern%20furniture%20open%20plan%20design%20contemporary%20African%20luxury%20apartment&width=1200&height=800&seq=cbd-living1&orientation=landscape',
      'https://readdy.ai/api/search-image?query=Modern%20penthouse%20kitchen%20with%20island%20sleek%20cabinets%20premium%20appliances%20city%20view%20through%20window%20contemporary%20design&width=1200&height=800&seq=cbd-kitchen1&orientation=landscape',
      'https://readdy.ai/api/search-image?query=Penthouse%20master%20bedroom%20with%20city%20view%20large%20windows%20modern%20bed%20contemporary%20furniture%20elegant%20decor%20urban%20luxury&width=1200&height=800&seq=cbd-bed1&orientation=landscape',
      'https://readdy.ai/api/search-image?query=Rooftop%20terrace%20of%20penthouse%20with%20outdoor%20furniture%20city%20skyline%20view%20evening%20lights%20urban%20African%20setting%20entertaining%20space&width=1200&height=800&seq=cbd-terrace1&orientation=landscape',
      'https://readdy.ai/api/search-image?query=Luxury%20bathroom%20with%20modern%20fixtures%20glass%20shower%20marble%20tiles%20city%20view%20window%20contemporary%20penthouse%20design&width=1200&height=800&seq=cbd-bath1&orientation=landscape'
    ],
    amenities: [
      { icon: 'ri-wifi-line', name: 'High-Speed Internet' },
      { icon: 'ri-shield-check-line', name: 'Building Security' },
      { icon: 'ri-temp-cold-line', name: 'Central AC' },
      { icon: 'ri-fire-line', name: 'Backup Power' },
      { icon: 'ri-elevator-line', name: 'Elevator Access' },
      { icon: 'ri-landscape-line', name: 'City Views' },
      { icon: 'ri-car-line', name: 'Secure Parking' },
      { icon: 'ri-service-line', name: 'Concierge' }
    ],
    nearby: [
      { icon: 'ri-building-line', name: 'Business Centers', distance: '0.1 km' },
      { icon: 'ri-hotel-line', name: 'Hotels', distance: '0.2 km' },
      { icon: 'ri-bank-line', name: 'Banks', distance: '0.1 km' },
      { icon: 'ri-restaurant-line', name: 'Fine Dining', distance: '0.2 km' }
    ],
    coordinates: {
      lat: 4.8501,
      lng: 31.5801
    },
    virtualTour: '',
    agent: {
      name: 'Diing Chan',
      title: 'Premium Rentals Manager',
      phone: '+211989222117',
      email: 'diing.chan@juwa.ss',
      photo: 'https://readdy.ai/api/search-image?query=Professional%20African%20male%20in%20business%20suit%20real%20estate%20manager%20confident%20portrait%20neutral%20background%20South%20Sudanese%20executive&width=200&height=200&seq=agent-simon1&orientation=squarish'
    }
  },
  {
    id: '12',
    propertyId: 'JUB012',
    title: 'Hai Jalaba Gated Estate',
    location: 'Hai Jalaba',
    address: 'Hai Jalaba Estate, Juba',
    price: 520000,
    currency: '$',
    type: 'sale',
    propertyType: 'House',
    bedrooms: 6,
    bathrooms: 5,
    parking: 3,
    area: 5500,
    livingRooms: 3,
    kitchens: 2,
    floors: 2,
    yearBuilt: 2021,
    ribbon: 'FOR SALE',
    description:
      'Magnificent estate home in the exclusive Hai Jalaba gated community. This exceptional property offers the ultimate in luxury living with expansive grounds, premium finishes throughout, and comprehensive amenities. The secure gated environment provides peace of mind while the generous spaces accommodate grand entertaining and comfortable family living.',
    gallery: [
      'https://readdy.ai/api/search-image?query=Luxury%20gated%20estate%20mansion%20in%20Hai%20Jalaba%20Juba%20with%20grand%20entrance%20columns%20large%20windows%20manicured%20grounds%20fountain%20driveway%20security%20gate%20prestigious%20African%20residence&width=1200&height=800&seq=jalaba-ext1&orientation=landscape',
      'https://readdy.ai/api/search-image?query=Grand%20foyer%20entrance%20hall%20of%20African%20mansion%20with%20marble%20floor%20chandelier%20curved%20staircase%20elegant%20decor%20double%20height%20ceiling%20luxury%20interior&width=1200&height=800&seq=jalaba-foyer1&orientation=landscape',
      'https://readdy.ai/api/search-image?query=Formal%20living%20room%20in%20African%20luxury%20estate%20with%20designer%20furniture%20artwork%20fireplace%20high%20ceiling%20elegant%20drapes%20premium%20finishes&width=1200&height=800&seq=jalaba-living1&orientation=landscape',
      'https://readdy.ai/api/search-image?query=Gourmet%20kitchen%20in%20luxury%20African%20home%20with%20custom%20cabinets%20marble%20island%20professional%20appliances%20butler%20pantry%20premium%20design&width=1200&height=800&seq=jalaba-kitchen1&orientation=landscape',
      'https://readdy.ai/api/search-image?query=Master%20suite%20in%20African%20mansion%20with%20sitting%20area%20king%20bed%20luxury%20bedding%20large%20windows%20elegant%20curtains%20walk-in%20closet%20dressing%20area&width=1200&height=800&seq=jalaba-master1&orientation=landscape',
      'https://readdy.ai/api/search-image?query=Infinity%20pool%20in%20luxury%20African%20estate%20with%20pool%20house%20landscaped%20gardens%20outdoor%20living%20area%20evening%20lighting%20entertainment%20space&width=1200&height=800&seq=jalaba-pool1&orientation=landscape',
      'https://readdy.ai/api/search-image?query=Home%20theater%20room%20in%20African%20mansion%20with%20large%20screen%20comfortable%20seating%20acoustic%20panels%20ambient%20lighting%20entertainment%20system&width=1200&height=800&seq=jalaba-theater1&orientation=landscape',
      'https://readdy.ai/api/search-image?query=Spa%20bathroom%20in%20luxury%20African%20home%20with%20jacuzzi%20tub%20walk-in%20shower%20double%20vanity%20marble%20tiles%20premium%20fixtures&width=1200&height=800&seq=jalaba-bath1&orientation=landscape'
    ],
    amenities: [
      { icon: 'ri-wifi-line', name: 'Smart Home System' },
      { icon: 'ri-shield-check-line', name: 'Gated Security' },
      { icon: 'ri-temp-cold-line', name: 'Central HVAC' },
      { icon: 'ri-fire-line', name: 'Generator System' },
      { icon: 'ri-water-flash-line', name: 'Borehole & Tank' },
      { icon: 'ri-lightbulb-line', name: 'Solar Array' },
      { icon: 'ri-swimming-line', name: 'Infinity Pool' },
      { icon: 'ri-film-line', name: 'Home Theater' },
      { icon: 'ri-home-gear-line', name: 'Staff Quarters' },
      { icon: 'ri-car-line', name: '3-Car Garage' }
    ],
    nearby: [
      { icon: 'ri-community-line', name: 'Gated Community', distance: '0 km' },
      { icon: 'ri-golf-ball-line', name: 'Sports Club', distance: '1.5 km' },
      { icon: 'ri-school-line', name: 'International School', distance: '2.0 km' },
      { icon: 'ri-plane-line', name: 'Juba Airport', distance: '4.0 km' }
    ],
    coordinates: {
      lat: 4.8378,
      lng: 31.5923
    },
    virtualTour: '',
    agent: {
      name: 'Diing Chan',
      title: 'Luxury Estate Director',
      phone: '+211989222117',
      email: 'diing.chan@juwa.ss',
      photo: 'https://readdy.ai/api/search-image?query=Sophisticated%20African%20woman%20luxury%20real%20estate%20agent%20elegant%20business%20attire%20confident%20professional%20portrait%20neutral%20background%20South%20Sudanese%20executive&width=200&height=200&seq=agent-victoria1&orientation=squarish'
    }
  }
];
